import type { ErrorCopyFor } from "@amtana/browser";
import type { ENRICHMENT_ERROR_CODES } from "@amtana/enrichment-contract";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// What a user reads when an enrichment fails (packages/module ADR-001).

const EN = {
  insufficientCreditsTitle: "You don't have enough AI credits",
  insufficientCreditsDescription: "Buy more credits to continue.",
  nothingToEnrichTitle: "Nothing to enrich",
  nothingToEnrichDescription:
    "All prospects already have the selected fields. Turn on Re-enrich to process them again.",
  notFoundTitle: "This enrichment doesn't exist",
  notFoundDescription: "It may have finished or been cancelled.",
} as const;

const ES: Translation<typeof EN> = {
  insufficientCreditsTitle: "No tienes suficientes créditos de IA",
  insufficientCreditsDescription: "Compra más créditos para continuar.",
  nothingToEnrichTitle: "Nada que enriquecer",
  nothingToEnrichDescription:
    "Todos los prospectos ya tienen los campos elegidos. Activa volver a enriquecer para procesarlos de nuevo.",
  notFoundTitle: "Este enriquecimiento no existe",
  notFoundDescription: "Puede que haya terminado o que se haya cancelado.",
};

export const ENRICHMENT_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const ENRICHMENT_ERROR_COPY = {
  enrichment_insufficient_credits: {
    title: phrase(ENRICHMENT_ERROR_CATALOGS, "insufficientCreditsTitle"),
    description: phrase(ENRICHMENT_ERROR_CATALOGS, "insufficientCreditsDescription"),
  },
  enrichment_nothing_to_enrich: {
    title: phrase(ENRICHMENT_ERROR_CATALOGS, "nothingToEnrichTitle"),
    description: phrase(ENRICHMENT_ERROR_CATALOGS, "nothingToEnrichDescription"),
  },
  enrichment_not_found: {
    title: phrase(ENRICHMENT_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(ENRICHMENT_ERROR_CATALOGS, "notFoundDescription"),
  },
} satisfies ErrorCopyFor<typeof ENRICHMENT_ERROR_CODES>;
